var formCaptchaId = null;
const captchaSitekeyCheckbox = process.env.CAPTCHA_SITEKEY_CHECKBOX,
    websiteContactApiUrl = process.env.WEBSITE_CONTACT_API_URL;

//

function get_prevsite() {
    const urlParams = new URLSearchParams(window.location.search);
    let source = urlParams.get('utm_source');
    let medium = urlParams.get('utm_medium');

    // Verifica sessionStorage para el referente original
    let ref = sessionStorage.getItem('original_ref');
    if (!ref) {
        // Si no se almacena ningún referente original, utiliza document.referrer o 'direct traffic' 
        ref = document.referrer || 'direct traffic';
        sessionStorage.setItem('original_ref', ref);
    }

    // Verifica sessionStorage para el sitio anterior
    let prevsite = sessionStorage.getItem('prevsite');

    // Almacena el document.referrer actual como el sitio anterior para la próxima visita
    sessionStorage.setItem('prevsite', document.referrer || 'direct traffic');

    return { ref, prevsite, source, medium };
}


//

document.addEventListener("DOMContentLoaded", () => {
    $("#form-get-started").submit(onFormSubmit)
    $(document).on("change", "input[type='checkbox']", function () {
        if ($(this).prop("checked")) {
            $(this).closest(".input-group-checkboxes").next(".error-field").remove();
        }
    })
})

function onFormSubmit(event) {
    event.preventDefault();
    let e = $("#fullname"),
        r = $("#organization"),
        a = $("#email"),

        // 
        q = $("#phone"),
        u = $("#country"),
        //

        o = $("#message"),
        i = $("#field_34"),
        form = $("#form-get-started"),
        n = !0;
    $(form).find(".error-field").remove();
    if (!grecaptcha.getResponse(formCaptchaId)) {
        $("#form-captcha").after(
            "<p id='error-captcha' class='error-field'>The captcha is missing or wrong.</p>"
        );
        n = !1;
    }
    //
    let otherService = $("#chk-service-other");

    if (otherService.val() == "" || otherService.val() == null || otherService.val() == undefined) {
        let checkbox = $("#input-group-checkboxes-service");
        if (!checkbox.find("input[type='checkbox']:checked").length) {
            $(checkbox).after(`<p class='error-field'>Select at least one option</p>`);
            n = !1;
        }
    }

    controls_fields(e) || (n = !1),
        controls_fields(r) || (n = !1),
        controls_fields(a) || (n = !1),
        controls_fields(o) || (n = !1),
        //
        controls_fields(q) || (n = !1),
        controls_fields(u) || (n = !1),
        //
        controls_fields(i) || (n = !1),
        n && submitForm();
}

async function submitForm() {
    let e = $("#fullname"),
        r = $("#organization"),
        a = $("#email"),
        // 
        q = $("#phone"),
        u = $("#country"),
        //
        i = $("#message"),
        s = $("#form-get-started"),
        ref = "",
        prevsite = "",
        captcharesponse = grecaptcha.getResponse(formCaptchaId),
        successUrl = "",
        url = "",
        device = "";
    (successUrl = $(s).attr("data-link")),
        (url = window.location.href),
        (device = get_device_type());

    let referrerData = get_prevsite();
    ref = referrerData.ref;
    prevsite = referrerData.prevsite;
    let source = referrerData.source || "";
    let medium = referrerData.medium || "";
    let gdprVal34 = $("#field_34").prop("checked");
    let suscription = $("#field_suscription").prop("checked");

    const fullName = e.val();
    const company = r.val();
    const email = a.val();

    //
    const phone = q.val();
    const country = u.val();
    //

    const comments = i.val();
    const chkServiceFunctional = $("#chk-service-functional").prop("checked") ? $("#chk-service-functional").val() : null,
        chkServiceAutomation = $("#chk-service-automation").prop("checked") ? $("#chk-service-automation").val() : null,
        chkServicePerformance = $("#chk-service-performance").prop("checked") ? $("#chk-service-performance").val() : null,
        chkServiceAccessibility = $("#chk-service-accessibility").prop("checked") ? $("#chk-service-accessibility").val() : null,
        chkServiceStrategy = $("#chk-service-strategy").prop("checked") ? $("#chk-service-strategy").val() : null,
        chkServiceSecurity = $("#chk-service-security").prop("checked") ? $("#chk-service-security").val() : null,
        chkServiceDevops = $("#chk-service-devops").prop("checked") ? $("#chk-service-devops").val() : null,
        chkServiceDevelopment = $("#chk-service-development").prop("checked") ? $("#chk-service-development").val() : null,
        chkAIServiceDevelopment = $("#chk-ai-service-development").prop("checked") ? $("#chk-ai-service-development").val() : null,
        chkWebMobileServiceDevelopment = $("#chk-web-mobile-service-development").prop("checked") ? $("#chk-web-mobile-service-development").val() : null,

        chkServiceOther = $("#chk-service-other").val();

    $(".btn-contact").addClass("loading");
    try {
        await contactGetStarted({
            email, fullName, organization: company, phone, country, message: comments,
            contactUrl: url, captcharesponse,
            chkServiceFunctional: !!chkServiceFunctional,
            chkServiceAutomation: !!chkServiceAutomation,
            chkServicePerformance: !!chkServicePerformance,
            chkServiceAccessibility: !!chkServiceAccessibility,
            chkServiceStrategy: !!chkServiceStrategy,
            chkServiceSecurity: !!chkServiceSecurity,
            chkServiceDevops: !!chkServiceDevops,
            chkServiceDevelopment: !!chkServiceDevelopment,
            chkAIServiceDevelopment: !!chkAIServiceDevelopment,
            chkWebMobileServiceDevelopment: !!chkWebMobileServiceDevelopment,

            chkServiceOther,

            acUserData: {
                email, name: fullName, company, phone, country, comments, form: "131",
                url, ref, prevsite, device, source, medium,
                gdpr2019: gdprVal34, suscription: suscription,
                serviceRequested: [chkServiceFunctional,
                    chkServiceAutomation,
                    chkServicePerformance,
                    chkServiceAccessibility,
                    chkServiceAccessibility,
                    chkServiceStrategy,
                    chkServiceSecurity,
                    chkServiceDevops,
                    chkServiceDevelopment,
                    chkAIServiceDevelopment,
                    chkWebMobileServiceDevelopment,
                    chkServiceOther].filter(v => v)
            }
        })
        $(".btn-contact").removeClass("loading");
        window.location.href = successUrl;
    }
    catch (e) {
        $(s).find('.btn-contact').removeClass("loading");
        $(s).find('.div-submit').after("<p class='error-field error-field-large'>There was an error, please try again.</p>");
        console.log(e)
    }
}


function contactGetStarted({ email, fullName, organization, phone, country, message, contactUrl, captcharesponse,
    chkServiceFunctional, chkServiceAutomation,
    chkServicePerformance, chkServiceAccessibility,
    chkServiceStrategy, chkServiceSecurity, chkServiceDevops, chkServiceDevelopment, chkAIServiceDevelopment, chkWebMobileServiceDevelopment, chkServiceOther, acUserData }) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: `${websiteContactApiUrl}/get-started`,
            data: JSON.stringify({
                email, fullName, organization, phone, country, message, contactUrl, captcharesponse,
                chkServiceFunctional, chkServiceAutomation,
                chkServicePerformance, chkServiceAccessibility,
                chkServiceStrategy, chkServiceSecurity, chkServiceDevops, chkServiceDevelopment, chkAIServiceDevelopment, chkWebMobileServiceDevelopment, chkServiceOther,
                acUserData
            }),
            contentType: "application/json",
            success: function (e) {
                if (e && e.errorMessage) reject(e);
                else resolve(e);
            },
            error: reject,
        });
    })
}

window.initCaptchas = function () {
    formCaptchaId = grecaptcha.render("form-captcha", {
        sitekey: captchaSitekeyCheckbox,
        callback: () => {
            $("#form-captcha").parent().find(".error-field").remove();
        }
    });
}